<template>
    <div class="container-trainerList">
      <SideHeader/>
      <div class="container-right-trainerList">
        <TopHeader
         :pathPage="path"
         :pathSubPage="subPath"
         :pathSubSubPage="subSubPath"
        />
        <div class="main-trainerList">
          <div class="">Ini Halaman Trainer List</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import SideHeader from "../../components/Header/SideHeader.vue"
  import TopHeader from "../../components/Header/TopHeader.vue"
  import {ref} from 'vue'
  
  export default {
    name: "TrainerList",
    components: {
      SideHeader,
      TopHeader,
    },
    setup() {
      let path = ref('Training')
      let subPath = ref('Trainer List')
      let subSubPath = ref(null)
      return {
        path,
        subPath,
        subSubPath
      };
    },
  };
  </script>
  
  <style lang="scss">
  @import "../../scss/Training/TrainerList.scss";
  </style>
  